var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flix-text-right",staticStyle:{"padding":"20px"}},[_c('nextAppointments')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }